import * as yup from 'yup';

export type HemerotecaSearchValues = {
	autor: string;
	titulo: string;
	year: string;
	tomo: string;
};

export const defaultValues: HemerotecaSearchValues = {
	autor: '',
	titulo: '',
	year: '',
	tomo: '',
};

export const formSchema: yup.ObjectSchema<HemerotecaSearchValues> = yup.object({
	autor: yup.string().trim().max(120, 'Máximo 120 caracteres').optional().default(''),
	titulo: yup.string().trim().max(200, 'Máximo 200 caracteres').optional().default(''),
	year: yup
		.string()
		.trim()
		.matches(/^$|^\d{4}$/, 'El año debe tener 4 dígitos')
		.optional()
		.default(''),
	tomo: yup
		.string()
		.trim()
		.matches(/^$|^TOMO-\d{3}$/, 'Formato de tomo inválido')
		.optional()
		.default(''),
});
